import React, { useEffect, useState } from 'react'
import FinanceRegisterModel from './models/FinanceRegisterModel'

function DeleteFinanceRegister({ FinanceRegisterData }) {
  const [deleteFinanceRegister, setDeleteFinanceRegister] = useState(new FinanceRegisterModel() || [])

  useEffect(() => {
    setDeleteFinanceRegister(FinanceRegisterData)
  }, [FinanceRegisterData])

  return (
    <>
      <div className="text-left px-2 pb-0">
        <p>
          <h6>Following Finance Register will be deleted and could not be recovered!!</h6>
          <ul>
            <li><b>Sales # :</b> {deleteFinanceRegister.SalesNumber}</li>
            <li><b>Customer Name :</b> {deleteFinanceRegister.CustomerName}</li>
            <li><b>Loan Application No :</b> {deleteFinanceRegister.LoanApplicationNo}</li>
          </ul>
        </p>
      </div>
      <div id="DeleteFinanceRegisterDetails" hidden>{JSON.stringify(deleteFinanceRegister)}</div>
    </>
  )
}

export default DeleteFinanceRegister